import {
  CLOSE_GET_STARTED_SECTION,
  GET_LIST_OF_APPS,
  GET_PLAN_SPECIFICATION_DETAILS,
  GET_TRANSACTION_LIMIT,
  SET_GET_STARTED_SECTION,
  SET_LIST_OF_APPS,
  SET_PLAN_SPECIFICATION_DETAILS,
  SET_TRANSACTION_LIMIT,
  UPDATE_ACTIVE_MANAGE_APP
} from "./actionTypes"

export const getListOfApps = (payload) => {
  return {
    type: GET_LIST_OF_APPS,
    payload: payload,
  }
}
export const setListOfApps = (payload) => {
  return {
    type: SET_LIST_OF_APPS,
    payload: payload,
  }
}
export const getPlanSpecificationDetails = (user, history) => {
  return {
    type: GET_PLAN_SPECIFICATION_DETAILS,
    payload: { user, history },
  }
}
export const setPlanSpecificationDetails = (payload) => {
  return {
    type: SET_PLAN_SPECIFICATION_DETAILS,
    payload: payload,
  }
}


export const updateActiveManageApp = (payload) => {
  return {
    type: UPDATE_ACTIVE_MANAGE_APP,
    payload: payload,
  }
}
export const closeGetStartedSection = (payload) => {
  return {
    type: CLOSE_GET_STARTED_SECTION,
    payload: payload
  }
}
export const setGetStartedSection = (payload) => {
  return {
    type: SET_GET_STARTED_SECTION,
    payload: payload
  }
}
export const getTransactionLimit = (payload) => {
  return {
    type: GET_TRANSACTION_LIMIT,
    payload: payload
  }
}
export const setTransactionLimit = (payload) => {
  return {
    type: SET_TRANSACTION_LIMIT,
    payload: payload
  }
}

